import { BiListPlus, BiSolidEditAlt } from "react-icons/bi";
import { DashboardLayout } from "./_common/DashboardLayout";
import { useEffect, useState } from "react";
import { userService } from "../utils/api";

export function Users() {
    const [users, setUsers] = useState([]);

    useEffect(() => {
        userService((data) => {
            if (data.success) {
                setUsers(data.users);
                console.table(data.users);
            }
        });
    }, []);
    return <DashboardLayout route="/users">
        <h1 className="text-4xl font-semibold flex justify-between items-center">
            <span>
                Users
            </span>

            <a href="/user/create" className="px-4 py-2 bg-cyan-500 text-white rounded-md hover:bg-cyan-600 text-lg flex items-center">
                <BiListPlus className="text-2xl mr-2" /> Add
            </a>
        </h1>

        <div className="mt-4">
            <div className="bg-white shadow-sm mt-6">
                <table className="w-full border border-gray-300">
                    <thead>
                        <tr className="border-b border-gray-300">
                            <th className="p-2 bg-stone-200"></th>
                            <th className="p-2 bg-stone-200">Name</th>
                            <th className="p-2 bg-stone-200">Email</th>
                            <th className="p-2 bg-stone-200">Username</th>
                            <th className="p-2 bg-stone-200">Created</th>
                            <th className="p-2 bg-stone-200">Edit</th>
                        </tr>
                    </thead>

                    <tbody className="text-center text-sm">
                        {users.map((user) => (
                            <tr key={user.id} className="border-b border-gray-300">
                                <td className="p-2">{user.icon}</td>
                                <td className="p-2">{user.first_name} {user.last_name}</td>
                                <td className="p-2">
                                    <a href={`mailto:${user.email}`}>{user.email}</a>
                                </td>
                                <td className="p-2">{user.username}</td>
                                <td className="p-2">{new Date(user.created_at).toLocaleDateString()}</td>
                                <td className="p-2">
                                    <a href={`/users/edit/${user.id}`} className="inline-block text-2xl text-cyan-500">
                                        <BiSolidEditAlt />
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </DashboardLayout>
}